import { WeenatColor } from '@weenat/theme'
import { isNil } from 'lodash-es'
import { memo } from 'react'
import { IconComponent } from '../Icon'
import MenuItem from '../MenuItem'
import Text from '../Text'
import { WeenatPressableProps } from '../WeenatPressable'

interface WeedgetContextMenuItemProps {
  Icon: IconComponent
  label: string
  color?: WeenatColor
  onPress: WeenatPressableProps['onPress']
  callback?: () => void
}

const WeedgetContextMenuItem: FC<WeedgetContextMenuItemProps> = ({
  Icon,
  label,
  color = 'grayscale.black',
  onPress,
  callback
}) => {
  return (
    <MenuItem
      onPress={(e) => {
        if (!isNil(onPress)) onPress(e)
        if (!isNil(callback)) callback()
      }}
    >
      <Flex $alignItems='center' $p='md' $gap='md'>
        <Icon $size='md' $color={color} />
        <Text $color={color} $fontWeight='medium' $lineHeight='none'>
          {label}
        </Text>
      </Flex>
    </MenuItem>
  )
}

export default memo(WeedgetContextMenuItem)
